import { memo } from "react";

export const LoadFromStart = memo(
  ({ onClick, loading }: { onClick: () => void; loading: boolean }) => {
    return (
      <div className="col-span-full flex items-center justify-center pb-2">
        <button
          type="button"
          onClick={onClick}
          disabled={loading}
          className="border-b border-blue-04 bg-transparent p-0 font-grotesque text-sm font-medium leading-none text-blue-04 disabled:opacity-50"
          aria-label="Load earlier pages from the beginning"
        >
          {loading ? "Loading…" : "Start From The Beginning"}
        </button>
      </div>
    );
  },
);

LoadFromStart.displayName = "LoadFromStart";
